import clsx from "clsx";
import styles from "./CustomProperties.module.scss";

interface ICustomProperties {
  children: React.ReactNode;
  /**
   * A class that declares CSS custom properties. They cascade into `children`
   * via inheritance — the consuming component only needs to read them.
   */
  className?: string;
}

/**
 * A non-rendering wrapper (`display: contents`) whose only job is to host CSS
 * custom properties and let them inherit into its subtree. It generates no
 * layout box, so it can wrap any element without affecting layout.
 *
 * Use it to push colors/sizing into a component that consumes custom properties
 * but is intentionally unaware of the concrete values — keeping that mapping in
 * the caller's own stylesheet.
 */
const CustomProperties = ({ children, className }: ICustomProperties) => (
  <span className={clsx(styles.forwarder, className)}>{children}</span>
);

export default CustomProperties;
